import {
  LeaseStepActionConst,
  LeaseDetailActionConst,
  ClearAllLeaseDetails,
  LeaseRenewalActionConst,
} from "../../constants/LeaseActionConst";
const initialState = {
  loader: false,
  allLease: [],
  leaseCreateStep: 1,
  leaseData: null,
  leaseUpdate: false,
  isRenewal: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case LeaseStepActionConst.LEASE_STEP_CHANGE:
      state = {
        ...state,
        leaseCreateStep: action.step,
      };
      break;

    case LeaseDetailActionConst.LEASE_DETAIL_DATA:
      state = {
        ...state,
        leaseData: action.data,
        leaseUpdate: true,
      };
      break;

    case ClearAllLeaseDetails.CLEAR_ALL_LEASE_DETAIL:
      state = {
        ...state,
        leaseData: null,
        leaseUpdate: false,
        // Don't reset isRenewal here - it should be cleared separately
      };
      break;

    case LeaseRenewalActionConst.LEASE_RENEWAL_MODE:
      console.log("Reducer - Setting isRenewal to:", action.isRenewal);
      state = {
        ...state,
        isRenewal: action.isRenewal,
      };
      break;

    case LeaseRenewalActionConst.CLEAR_LEASE_RENEWAL_MODE:
      console.log("Reducer - Clearing isRenewal");
      state = {
        ...state,
        isRenewal: false,
      };
      break;

    default:
      break;
  }
  return state;
};
